import { faDownload } from '@fortawesome/free-solid-svg-icons';
import upperFirst from 'lodash/upperFirst';
import React, {useState} from 'react';
import useCurrentUser from '../../../../hooks/useCurrentUser';
import useFluent from '../../../../hooks/useFluent';
import {useBasicTrailDetail} from '../../../../queries/trails/useBasicTrailDetail';
import {trailDetailLink} from '../../../../routing/Utils';
import {BasicIconInTextCompact, ShadowButton, ShadowButtonIcon} from '../../../../styling/styleUtils';
import {downloadGPXString} from '../../../../utilities/trailUtils';
import SignUpModal from '../../../sharedComponents/SignUpModal';
import JoinPatreonModal from '../../../sharedComponents/patreon/JoinPatreonModal';
import PatreonLockedButton from '../../../sharedComponents/patreon/PatreonLockedButton';

interface Props {
  id: string;
}

const TrailDetails = (props: Props) => {
  const {id} = props;
  const getString = useFluent();
  const user = useCurrentUser();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const {loading, error, data} = useBasicTrailDetail(id);

  if (loading) {
    return null;
  } else if (error !== undefined) {
    console.error(error);
    return null;
  } else if (data !== undefined && data.trail && data.trail.line) {
    const line = data.trail.line;
    const name = data.trail.name ? data.trail.name : upperFirst(getString('global-formatted-trail-type', {
      type: data.trail.type,
    }));

    const onClick = () => {
      if (user && user.membershipLevel) {
        downloadGPXString({
          line,
          name,
          url: 'https://wilderlist.app' + trailDetailLink(id),
        });
      }  else {
        setModalOpen(true);
      }
    };

    const signUp = modalOpen ? (
      <>
        {!user &&
          <SignUpModal
            onCancel={() => setModalOpen(false)}
          />
        }
        {user && !user.membershipLevel &&
          <JoinPatreonModal
            title='Download any trail or route by becoming a Patreon member!'
            onCancel={() => setModalOpen(false)}
          />
        }
      </>
    ) : null;

  if (user && user.membershipLevel) {
        return (
          <>
            <ShadowButton
              onClick={onClick}
              title={getString('download-gpx-button')}
            >
              <ShadowButtonIcon>
                <BasicIconInTextCompact icon={faDownload} />
              </ShadowButtonIcon>
              {getString('download-gpx-button')}
            </ShadowButton>
            {signUp}
          </>
        );
      } else {
        return (
          <>
            <PatreonLockedButton onClick={onClick}>
              <ShadowButtonIcon>
                <BasicIconInTextCompact icon={faDownload} />
              </ShadowButtonIcon>
              {getString('download-gpx-button')}
            </PatreonLockedButton>
            {signUp}
          </>
        );
      }
  } else {
    return null;
  }

};

export default TrailDetails;
